/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invalid_Youtube_UrlInputs */

const en_invalid_youtube_url = /** @type {(inputs: Invalid_Youtube_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invalid YouTube URL`)
};

const es_invalid_youtube_url = /** @type {(inputs: Invalid_Youtube_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL de YouTube no válida`)
};

const fr_invalid_youtube_url = /** @type {(inputs: Invalid_Youtube_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL YouTube invalide`)
};

const de_invalid_youtube_url = /** @type {(inputs: Invalid_Youtube_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ungültige YouTube-URL`)
};

const ja_invalid_youtube_url = /** @type {(inputs: Invalid_Youtube_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無効なYouTube URL`)
};

const zh_invalid_youtube_url = /** @type {(inputs: Invalid_Youtube_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无效的 YouTube 链接`)
};

const ar_invalid_youtube_url = /** @type {(inputs: Invalid_Youtube_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رابط YouTube غير صالح`)
};

const id_invalid_youtube_url = /** @type {(inputs: Invalid_Youtube_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL YouTube tidak valid`)
};

const it_invalid_youtube_url = /** @type {(inputs: Invalid_Youtube_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL YouTube non valido`)
};

const ru_invalid_youtube_url = /** @type {(inputs: Invalid_Youtube_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Недействительный URL-адрес YouTube`)
};

const pt_invalid_youtube_url = /** @type {(inputs: Invalid_Youtube_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL do YouTube inválido`)
};

const ko_invalid_youtube_url = /** @type {(inputs: Invalid_Youtube_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`잘못된 YouTube URL`)
};

/**
* | output |
* | --- |
* | "Invalid YouTube URL" |
*
* @param {Invalid_Youtube_UrlInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const invalid_youtube_url = /** @type {((inputs?: Invalid_Youtube_UrlInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invalid_Youtube_UrlInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invalid_youtube_url(inputs)
	if (locale === "es") return es_invalid_youtube_url(inputs)
	if (locale === "fr") return fr_invalid_youtube_url(inputs)
	if (locale === "de") return de_invalid_youtube_url(inputs)
	if (locale === "ja") return ja_invalid_youtube_url(inputs)
	if (locale === "zh") return zh_invalid_youtube_url(inputs)
	if (locale === "ar") return ar_invalid_youtube_url(inputs)
	if (locale === "id") return id_invalid_youtube_url(inputs)
	if (locale === "it") return it_invalid_youtube_url(inputs)
	if (locale === "ru") return ru_invalid_youtube_url(inputs)
	if (locale === "pt") return pt_invalid_youtube_url(inputs)
	return ko_invalid_youtube_url(inputs)
});